import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate(['CONNECTION_STATE_CHANGED']);
